export default __webpack_public_path__ + "static/media/charging-point.9703cc10.svg";